<template>
  <div class="report-page">
    <div v-if="totalCount > 0" class="article-list-box">
      <el-row class="mine-list">
        <div class="content">
          <ul class="article-list">
            <li class="item" v-for="(item,key) in tableData" :key="item.id">
              <a :href="item.content">
                <img :src="item.picUrl" alt class="thumbnail-img" />
              </a>
              <h2 class="title">
                <a class="title-a" :href="item.content">{{item.title}}</a>
              </h2>
              <span class="time">{{timeToDate(item.createTime)}}</span>
              <p class="summary" v-if="item.summary">
                <span>{{item.summary}}</span>......
                <a :href="item.content">查看详情</a>
              </p>
              <div class="setting-fn" v-if="role.indexOf('article')>-1">
                <a href="javascript:;" class="modify" @click="handleModify(item)">修改</a>
                <span style="padding: 0 3px">|</span>
                <a href="javascript:;" class="delete" @click="handleDelete(item,key)">删除</a>
              </div>
            </li>
          </ul>
        </div>
      </el-row>
      <el-row class="mb40">
        <div class="pager-center">
          <el-pagination
            @current-change="getList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totalItem"
          ></el-pagination>
        </div>
      </el-row>
    </div>
    <div v-else-if="totalCount === -1" class="empty-page"></div>
    <div v-else class="empty-page">
      <img src="../assets/empty.png" alt />
      <span style="color: #c5c5c5">暂时为空</span>
    </div>
    <div class="footer">
      <div class="inner">
        <div>Copyright © 2017-2020 TEG 用户体验设计中心. All Rights Reserved.</div>
        <div>
          <span>问题反馈&咨询建议 邮箱：hanxiaoting@58.com</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../utils/http";
import { MSG } from "../utils/utils";
import { htmlToTxtMixin } from "../utils/mixins.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Report",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      interface: {
        saveReport: `/article/save`,
        deleteReport: `/article/del`,
        getList: `/article/list`
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalItem: 10,
      totalCount: -1,
      type: 0
    };
  },
  computed: {
    ...mapGetters(["attention", "role"])
  },
  mounted() {
    if (this.$route.path.indexOf("/report") !== -1) {
      this.type = 0;
    } else {
      this.setAttention(1);
      this.type = 1;
    }
    this.getList();
  },
  methods: {
    getList() {
      http
        .get(this.interface.getList, {
          page: this.currentPage,
          pageSize: this.pageSize,
          type: this.type
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.totalCount = data.totalCount;
            this.tableData = data.recordList;
            this.totalItem = data.totalPage * this.pageSize;
          } else {
            MSG.error(message);
          }
        });
    },
    handleDelete(item, index) {
      this.$confirm("确定要删除该报告?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http
          .post(this.interface.deleteReport, {
            id: item.id
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              this.getList();
              MSG.success(message);
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      });
    },
    handleModify(item) {
      this.$router.push({
        path: "/report/articleUpdate",
        query: {
          ...item
        }
      });
    },
    timeToDate(date) {
      return date.split(" ")[0];
    },
    ...mapActions(["setAttention"])
  }
};
</script>
<style lang="scss" scoped>
.report-page {
  height: 100%;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .article-list-box {
    flex: 1;
  }
}
.content {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  .article-list {
    margin: 15px 50px 0 50px;
    width: 90%;
    .item {
      width: 100%;
      background-color: #fff;
      position: relative;
      overflow: hidden;
      zoom: 1;
      padding: 20px 0;
      color: #666666;
      border-bottom: 1px solid #dcdcdc;
      &:last-child {
        border-bottom: 0;
      }
      .thumbnail-img {
        float: left;
        width: 190px;
        height: 107px;
        line-height: 130px;
        overflow: hidden;
        margin-right: 20px;
        background-color: #fff;
        text-align: center;
        box-sizing: border-box;
        max-width: 100%;
        vertical-align: middle;
        border: 0;
      }
      .title {
        font-size: 20px;
        margin: 0 0 8px;
        a {
          color: #333;
          &:hover {
            color: #2494ea;
          }
        }
      }
      .time {
        position: absolute;
        bottom: 20px;
        color: #666666;
      }
      .setting-fn {
        position: absolute;
        right: 0;
        bottom: 20px;
        a {
          color: #ff552e;
        }
      }
      .summary {
        font-size: 14px;
        line-height: 24px;
        height: 48px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        a {
          font-size: 14px;
          color: #2494ea;
          &:hover {
            text-decoration: none;
          }
          &:-webkit-any-link {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.top-notice {
  background-color: #fdeed2;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}
.empty-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  flex: 1;
}
.mb40 {
  margin: 20px auto;
}
.pager-center {
  display: flex;
  justify-content: center;
}
.footer {
  padding-top: 20px;
  text-align: center;
  font-size: 12px;
  color: #c5c5c5;
  height: 60px;
}
.footer .inner {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/articleList.vue